export class PwValueUnit {

    constructor(json: any) {
        if (json) {
            Object.assign(this, json);
        }
    }

    value = 0;
    unit: string;
}
